// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"516":"f94f9be6","706":"86926888","854":"86926888"}[chunkId] + ".css";
};